import { render, staticRenderFns } from "./AppointmentSetup.vue?vue&type=template&id=658f9786&scoped=true"
import script from "./AppointmentSetup.vue?vue&type=script&lang=js"
export * from "./AppointmentSetup.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSetup.vue?vue&type=style&index=0&id=658f9786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f9786",
  null
  
)

export default component.exports